var _style, _g, _g2, _g3, _g4, _g5, _g6, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _defs4, _rect4, _defs5, _rect5, _defs6, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpiritLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 632.9 162",
    style: {
      enableBackground: "new 0 0 632.9 162"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st3{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st4{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\n\t.st5{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie_5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie_4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie_2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M619.6,113.9c-4.2-1-8.6,1.3-10.2,2.2c-0.9,0.5-1.8,1-2.8,1.3c-2.7,0.9-7.3,2-11.4,0 c-3.2-1.9-8.9-6.1-12.3-13.3C578,94,568,87,568,87c-0.4,0.8-1.8,1.8-3,2.6l0,0c9.1-14.7,7.8-28,1.6-38.2c-3.6-5.9-4.9-7-9.3-17.7 c-7.6-21.3-48.3-16.4-51.5-22.8c-3.3-6.6-9.3-2-11-4.2s2.8-7.7-0.6-6.5c-3.7,1.4-11,12,6.6,20.7c11.4,5.6,14.2,14.8,14.9,19.9 c0.3,2.8-0.2,5.6-1.7,8c-3.2,5.2-8.9,10.5-8.9,19.2c0,12,6.5,17.8,6.5,17.8c-8.5-5.2-8.9-17.8-8.9-17.8c-2.3-0.4-4.1-0.4-6.3-0.2 l-5.1,25h-27.6l-14.2,48.8l9.9-49.5l-8.3-3.3h8.9h0.8h27.4l5.1-25.1h-88.7l-5.1,25.1h28.1l-14.1,71h32.4l0,0 c77.7-0.5,113.6-32.7,113.6-32.7c-1.4-1.3-4-1.9-4-1.9s15-0.3,33.2,12.8c8,5.7,16.8,13.8,20.9,10.6c2.6-2-3.5-4.3-3.7-8.3 c-0.1-0.8,0.2-1.7,0.7-2.4c1.8-2.7,8.4-11.3,24.9-14.2C636.9,122.7,626.2,115.4,619.6,113.9z M531.8,61.9c-0.3,0-0.6-0.1-0.8-0.3 c0.4-0.4,0.7-1,0.7-1.7c0-1.1-0.7-2-1.6-2c-0.2,0-0.4,0.1-0.6,0.2c0-0.3,0-0.5,0-0.8c0-2.5,1-4.6,2.3-4.6s2.3,2.1,2.3,4.6 S533.1,61.9,531.8,61.9z M541.3,84.9c-1.4,0-2.5-2.2-2.5-4.8c0-2.7,1.1-4.8,2.5-4.8s2.5,2.2,2.5,4.8 C543.9,82.8,542.7,84.9,541.3,84.9z M550.8,61.9c-0.3,0-0.6-0.1-0.8-0.3c0.4-0.4,0.7-1,0.7-1.7c0-1.1-0.7-2-1.6-2 c-0.2,0-0.4,0.1-0.6,0.2c0-0.3,0-0.5,0-0.8c0-2.5,1-4.6,2.3-4.6s2.3,2.1,2.3,4.6S552,61.9,550.8,61.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st0",
    width: 632.97,
    height: 161.97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M195.9,95.6c0,24.3-19.1,40.6-48.6,40.6h-16.6l-4.7,23.6H93.6l19.2-96.1h42.7 C181.3,63.8,195.9,75.6,195.9,95.6z M163.1,98.5c0-6.9-4.7-9.8-12.1-9.8h-10.8l-4.5,22.5H149C157.9,111.3,163.1,106.6,163.1,98.5 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st1",
    width: 632.97,
    height: 161.97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_11"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M213.5,63.8h32.4l-19.2,96.1h-32.4L213.5,63.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st2",
    width: 632.97,
    height: 161.97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_10"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M318.6,131.8l16.1,28H301l-13.6-24.2h-8l-4.8,24.2h-32.4l19.2-96.1h43.1c25.4,0,39.9,11.7,39.9,31.6 C344.5,112.5,334.9,125.7,318.6,131.8z M299.7,88.7h-10.8l-4.5,22.5h13.3c8.9,0,14.1-4.7,14.1-12.8 C311.7,91.6,307.1,88.7,299.7,88.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st3",
    width: 632.97,
    height: 161.97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_9"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M363.8,63.8h32.4L377,159.9h-32.4L363.8,63.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st4",
    width: 632.97,
    height: 161.97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_8"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M0,152.3l12.5-23.9c10.7,6.2,21.7,8.9,32.4,8.9c8.4,0,12.8-2.2,12.8-5.6c0-10.2-45.7-4.3-45.7-34 c0-21.8,18.3-36.1,48.6-36.1c14.3,0,27,2.9,36,8.2L84.8,93.4c-7.7-4.8-17-7.1-26.4-7.1c-9.5,0-14.1,3.2-14.1,6.5 c0,10.6,45.8,3.8,45.8,33.5c0,21.4-18.7,35.8-48.6,35.8C24.4,162,9.2,157.9,0,152.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5877,
    y1: -8.9936,
    x2: 631.9961,
    y2: 171.4863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595A"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 0.03,
    className: "st5",
    width: 632.97,
    height: 161.97
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritLogo);
export default __webpack_public_path__ + "static/media/Spirit-logo.d36ce199bceab01d78585b57ac9fb43e.svg";
export { ForwardRef as ReactComponent };